import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Space,
  Table,
  Tag,
  Pagination,
  Card,
  Empty,
  Divider,
} from "antd";
import "./AdminOrderList.css";
import { get } from "../../apiService";
import TitleComp from "./TitleComp";
import moment from "moment/moment";
import { FaClock, FaFilePdf } from "react-icons/fa";
import Pdf from "../Export/Pdf";
import Excel from "../Export/Excel";

const AdminOrderList = () => {
  const [loading, setLoading] = useState(false);
  const [getData, setGetData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const exportColumn = [
    { title: "Avg Weight", dataIndex: "avg_wt", key: "avg_wt" },
    { title: "Sieve", dataIndex: "sive_sizes", key: "sive_sizes" },
    { title: "Size (MM)", dataIndex: "diam_mm", key: "diam_mm" },
    { title: "Colour", dataIndex: "color", key: "color" },
    { title: "Shade", dataIndex: "shade", key: "shade" },
    { title: "Cut", dataIndex: "cut", key: "cut" },
    { title: "Clarity", dataIndex: "clarity", key: "clarity" },
    { title: "Price", dataIndex: "price", key: "price" },
    // { title: "Type", dataIndex: "typeSelect", key: "typeSelect" },
    // { title: "Selected Type", dataIndex: "updateCarat", key: "updateCarat" },
    { title: "Total Weight", dataIndex: "total_weight", key: "total_weight" },
    { title: "Value", dataIndex: "subtotal", key: "subtotal" },
  ];

  const fetchOrder = async (current, pageSize, search) => {
    // alert('qwertyu')
    setLoading(true);

    try {
      // Replace with actual fetch logic
      const response = await get(
        `/orders.php?action=fetch&limit=${pageSize}&page=${current}${
          search ? "&search=" + search + "" : ""
        }`
      );
      console.log(response);
      if (response) {
        setPagination((prev) => ({
          ...prev,
          current,
          pageSize,
          total: response.total, // Set total based on response
        }));
        setGetData(response.list);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;
    setPagination({
      ...pagination,
      current,
      pageSize,
    });

    fetchOrder(current, pageSize);
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchOrder(pagination.current, pagination.pageSize, searchInput);
    }, 300);
    return () => clearTimeout(dbounce);
  }, [pagination.current, pagination.pageSize, searchInput]);

  const columns = [
    {
      title: "OrderId",
      dataIndex: "order_id",
      width: "5%",
    },

    {
      title: "Customer Name",
      dataIndex: "name",
      width: "7%",
    },
    {
      title: "Staff",
      dataIndex: "staff_name",
      width: "3%",
    },
    {
      title: "Payment Type",
      dataIndex: "payment_type",
      key: "payment_type",
      width: "3%",
    },

    {
      title: "Order Status",
      dataIndex: "order_status",
      render: (_, record) => {
        let color = record.order_status === "success" ? "#52c41a" : "#ff4d4f";
        return <Tag color={color}>{record.order_status}</Tag>;
      },
      width: "3%",
    },

    {
      title: "Total Amount",
      dataIndex: "total",
      render: (_, record) => {
        let color = record.order_status === "success" ? "#52c41a" : "#ff4d4f";
        return <>$ {record.total}</>;
      },
    },
    {
      title: "Comment",
      dataIndex: "comment",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (text) => moment(text).format("llll"),
      width: "10%",
    },
    {
      title: "Action",
      dataIndex: "invoice_link",
      key: "invoice_link",
      render: (text, record) =>
        record && (
          <div className="buttonGroup d-flex">
            <Pdf
              column={exportColumn}
              comment={record.comment}
              data={
                record.products.length > 0
                  ? [
                      ...record.products,
                      {
                        price: "Total",
                        total_weight: record.total_weight,
                        subtotal: record.sub_total,
                      },
                      {
                        price: "Shipping",
                        total_weight: "",
                        subtotal: record.shipping_charges,
                      },
                      {
                        price: "Net Total",
                        total_weight: "",
                        subtotal: record.total,
                      },
                    ]
                  : []
              }
              fileName={record.name + " " + record.created_at}
            />
            &nbsp;
            <Excel
              column={exportColumn}
              comment={record.comment}
              data={
                record.products.length > 0
                  ? [
                      ...record.products?.sort((a, b) => a.avg_wt - b.avg_wt),
                      {
                        price: "Total",
                        total_weight: record.total_weight,
                        subtotal: record.sub_total,
                      },
                      {
                        price: "Shipping",
                        total_weight: "",
                        subtotal: record.shipping_charges,
                      },
                      {
                        price: "Net Total",
                        total_weight: "",
                        subtotal: record.total,
                      },
                    ]
                  : []
              }
              fileName={record.name + " " + record.created_at}
            />
          </div>
        ),
    },
  ];

  const statusClasses = {
    success: "text-success",
    pending: "text-warning",
    cancel: "text-danger",
  };

  const formatValue = (value, data) => {
    // Format specific fields as monetary values
    const monetaryFields = ["sub_total", "shipping_charges", "total"];
    if (monetaryFields.includes(value)) {
      return data[value] ? "$ " + data[value] : "";
    }
    return data[value];
  };

  const getClass = (value) => {
    // Return appropriate class based on status
    return statusClasses[value] || "";
  };

  const columnsNew = [
    {
      title: "OrderId",
      dataIndex: "order_id",
    },

    {
      title: "Customer Name",
      dataIndex: "name",
    },
    {
      title: "Staff",
      dataIndex: "staff_name",
    },
    { title: "Payment Type", dataIndex: "payment_type", key: "payment_type" },
    { title: "Order Status", dataIndex: "order_status", key: "order_status" },
    { title: "Subtotal", dataIndex: "sub_total", key: "sub_total" },
    {
      title: "Shipping",
      dataIndex: "shipping_charges",
      key: "shipping_charges",
    },
    { title: "Total", dataIndex: "total", key: "total" },
  ];

  return (
    <div className="p-3">
      <TitleComp
        name="Orders List"
        type="Orders"
        totalData={pagination.total}
        setSearchInput={setSearchInput}
        searchInput={searchInput}
      />
      {isMobile ? (
        <div className="user-list-cards">
          <div className="row">
            {getData.length > 0 ? (
              getData.map((data, index) => (
                <div className="col-md-4 col-sm-6 mb-4">
                  <Card key={index}>
                    <div className="bookedDate d-flex align-items-center mb-3">
                      <FaClock />
                      &nbsp;&nbsp;{moment(data.created_at).format("llll")}
                    </div>

                    {columnsNew.map((value, i) => (
                      <div className="row" key={i}>
                        <div className="col-4">
                          <strong>{value.title}</strong>
                        </div>
                        <div className="col-2">:</div>
                        <div
                          className="col-6 d-flex align-items-center justify-content-end"
                          style={{ textTransform: "capitalize" }}
                        >
                          {statusClasses[data[value.dataIndex]] ? (
                            <span className={getClass(data[value.dataIndex])}>
                              {data[value.dataIndex]}
                            </span>
                          ) : (
                            formatValue(value.dataIndex, data)
                          )}
                        </div>
                      </div>
                    ))}
                    <Divider />
                    <div className="buttonGroup d-flex">
                      <Pdf
                        column={exportColumn}
                        comment={data.comment}
                        data={
                          data.products.length > 0
                            ? [
                                ...data.products,
                                {
                                  price: "Total",
                                  total_weight: data.total_weight,
                                  subtotal: data.sub_total,
                                },
                                {
                                  price: "Shipping",
                                  total_weight: "",
                                  subtotal: data.shipping_charges,
                                },
                                {
                                  price: "Net Total",
                                  total_weight: "",
                                  subtotal: data.total,
                                },
                              ]
                            : []
                        }
                        fileName={data.name + " " + data.created_at}
                      />
                      &nbsp;
                      <Excel
                        column={exportColumn}
                        comment={data.comment}
                        data={
                          data.products.length > 0
                            ? [
                                ...data.products?.sort(
                                  (a, b) => a.avg_wt - b.avg_wt
                                ),
                                {
                                  price: "Total",
                                  total_weight: data.total_weight,
                                  subtotal: data.sub_total,
                                },
                                {
                                  price: "Shipping",
                                  total_weight: "",
                                  subtotal: data.shipping_charges,
                                },
                                {
                                  price: "Net Total",
                                  total_weight: "",
                                  subtotal: data.total,
                                },
                              ]
                            : []
                        }
                        fileName={data.name + " " + data.created_at}
                      />
                    </div>
                  </Card>
                </div>
              ))
            ) : (
              <Empty />
            )}
          </div>
        </div>
      ) : (
        <div className="table-container">
          <Table
            columns={columns}
            dataSource={getData}
            pagination={false}
            onChange={handleTableChange}
          />
        </div>
      )}
      <div className="mt-3">
        <Pagination
          current={pagination.current}
          total={pagination.total}
          onChange={(page) =>
            setPagination((prev) => ({ ...prev, current: page }))
          }
        />
      </div>
    </div>
  );
};

export default AdminOrderList;
